import {GeneralStatusEnum} from "../enums/GeneralStatusEnum";
import {UserRoleEnum} from "../enums/UserRoleEnum";
import {IApiUser} from "../services/nestjs-base-api/types";

export class Utils {
    public static readableGeneralStatus(status: GeneralStatusEnum) {
        switch (status) {
            case GeneralStatusEnum.Active:
                return "Active";
            case GeneralStatusEnum.Suspended:
                return "Suspended";
            case GeneralStatusEnum.Deleted:
                return "Deleted";
            default:
                return status;
        }
    }

    public static readableUserRole(role: UserRoleEnum) {
        switch (role) {
            case UserRoleEnum.OrganisationAdmin:
                return "Organisation administrator";
            case UserRoleEnum.OrganisationViewer:
                return "Organisation viewer";
            default:
                return role;
        }
    }

    public static userIsSuperAdmin(user: IApiUser) {
        const roles = JSON.parse(user.roles);

        return !!roles.includes(UserRoleEnum.SuperAdmin);
    }

    public static limitAndRound(value: number, min: number, max: number, decimals: number) {
        if (value) {
            const limitedValue = (value < min) ? min : (value > max) ? max : value;

            return limitedValue.toFixed(decimals);
        } else if (value === 0) {
            const limitedValue = 0;

            return limitedValue.toFixed(decimals);
        } else {
            return '-';
        }
    }
}
